export const navigateToLeaseApplication = ({ location }) => {
  let link = `/${location?.companyInfo?.id}/applicant/app/applications/form/create/?cId=${location?._id}`;
  if (location.aptlyScreening?.type === 'custom') {
    if (!location.aptlyScreening?.active) return; //inactive screening
    link = location.aptlyScreening.link;
  }
  window.open(link, '_blank');
};
